// Adapted prompts, not ranked claims. Provenance is recorded in README.md.
export const musicThemes = [
  "A cover that gives a familiar song a new life",
  "An instrumental that says plenty without words",
  "A song that tells a complete story",
  "A track with an unforgettable horn section",
  "Music for your imaginary movie's opening scene",
  "Your entrance music for a championship match",
  "A song from a debut album you still love",
  "A song in a language you don't speak",
  "A song that brings a place to mind",
  "A road-trip song for the open highway",
  "A song with a number in its title",
  "A song with vocal harmonies worth hearing twice",
  "A song that sounds like summer",
  "A track for a rainy afternoon",
  "A duet with unforgettable chemistry",
  "A song with a color in the title",
  "A song that takes you back to childhood",
  "An album closer that ends things perfectly",
  "A song for watching the sunrise",
  "A song you wish more people knew",
];
export const skeetThemes = [
  "A post that taught you something surprising",
  "A tiny story with a brilliant ending",
  "A post that made you laugh out loud",
  "A kind moment worth sharing",
  "An unexpected opinion you can appreciate",
  "A discovery you wish you'd made sooner",
  "A post that captures everyday chaos",
  "An excellent animal encounter",
  "A clever use of very few words",
  "A question that started a great conversation",
  "A beautifully unexpected photograph",
  "A recommendation worth trying",
  "A small victory worth celebrating",
  "A perfect description of a familiar feeling",
  "A creative project that deserves attention",
  "An unusually good pun",
  "A thoughtful change of perspective",
  "A delightful bit of local history",
  "A useful tip for everyday life",
  "A post with wonderful main-character energy",
];
export function suggestThemes(kind: string) {
  const pool = kind === "music" ? musicThemes : skeetThemes;
  const choices = [...pool];
  for (let i = choices.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [choices[i], choices[j]] = [choices[j], choices[i]];
  }
  return choices.slice(0, 20);
}
